import * as z3 from "zod";
import * as z from "zod/v4";

export const RefreshTypesSchema = z.enum(["daily", "never"]).catch("daily");
export const RefreshTypesSchemaZ3 = z3.enum(["daily", "never"]).catch("daily");
export const ItemCountdownSchema = z.object({
  id: z.number(),
  uuid: z.uuid(),
  itemId: z.number(),
  itemName: z.string(),
  itemUuid: z.string(),
  refreshType: RefreshTypesSchema,
  startAt: z.string(),
  startingCount: z.coerce.number(),
  discardedAt: z.string().nullable(),
});

export type ItemCountdown = z.infer<typeof ItemCountdownSchema>;
export const ItemCountdownsSchema = z.array(ItemCountdownSchema);

export const ItemCountSchema = z.object({
  id: z.number(),
  uuid: z.uuid(),
  itemId: z.number(),
  itemUuid: z.string(),
  itemName: z.string(),
  refreshType: RefreshTypesSchema,
  startingCount: z.coerce.number(),
  startAt: z.string(),
  discardedAt: z.string().nullable(),
  totalMoved: z.coerce.number(),
});
export const ItemCountsSchema = z.array(ItemCountSchema);
export type ItemCount = z.infer<typeof ItemCountSchema>;
